import {useResultPageStore} from '../stores/ResultPageStore';
import Job from './../model/Job';
import {
    EVENT_JOB_COMPLETE,
    EVENT_JOB_FAIL,
    EVENT_JOB_INIT_SUCCESS, EVENT_JOB_SELECT_OUTPUT,
    EVENT_JOB_START,
    EVENT_JOB_SYS_SUCCESS
} from '../events/job.events';
import {
    JOB_STATE_COMPLETE, JOB_STATE_DRAFT,
    JOB_STATE_FAILED,
    JOB_STATE_INCOMPLETE,
    JOB_STATE_NOT_FOUND,
    JOB_STATE_PROCESSING, JOB_STATE_SELECT_OUTPUT,
} from '../const/job.const';
import {EventBus} from '../events/event.bus';
import ApiManager from './ApiManager';
import {decodeBase64ToImageUrl, encodeImageToBase64} from '../../../../../helper/base64';
import {satReconvert} from '../../../../../../lib-sat/result/util/reconvert';
import Analytics from "../util/Analytics";
import {testIsNonEmptyString} from "../../../../../../lib/test-and-assert/test-base";
import FileManager from "../../aicreatorstudio/manager/FileManager";
import CanvasManager from "./CanvasManager";
import ApiJob from "../model/ApiJob";
import {axiosWrapper} from "../../../../../../lib/axios-wrapper/axios-wrapper";
import {globalLogger} from "../../../../../helper/global-logger";
import {satGlobals} from "../../../../../sat/helper/sat-globals";

class JobManager {
    listener = false;

    constructor() {
    }

    create() {
        this.store = useResultPageStore();

        const job = new Job();
        this.store.addJob(job);

        return job.id;
    }

    async delete(job) {
        Analytics.send('result_job', 'delete', job);
        await ApiManager.delete(job.apiJob.id);
    }

    listen() {
        if (this.listener === true) {
            return;
        }

        this.listener = true;

        EventBus.$on(EVENT_JOB_START, (data) => {
            this.start(data.id);
        });
    }

    async start(jobId) {
        this.store = useResultPageStore();
        let job = this.store.getJobById(jobId);
        job.state = JOB_STATE_PROCESSING;
        let activeStage = job.getActiveStageJob();

        activeStage.activeStep = 'select_output'
        EventBus.$emit(EVENT_JOB_SELECT_OUTPUT, {});

        let prompt = FileManager.fromText('prompt.txt', 'prompt', activeStage.settings.prompt);

        let apiJob = await ApiManager.create({operation: 'ai_inpainting'});

        await ApiManager.uploadBase64(apiJob, prompt);

        let mask = FileManager.fromImage('mask.png', 'mask_image', activeStage.canvas.mask);
        await ApiManager.uploadBase64(apiJob, mask);

        let baseImageInitial = await this.encodeImageToBase64Url(activeStage.mainJob.apiJob.output[0].uri);
        let baseImageFinal  = this.decodeBase64ToImageUrl(baseImageInitial, 'image/png');

        let baseImage = FileManager.fromImage('base_image.png', 'base_image', baseImageFinal);

        await ApiManager.uploadBase64(apiJob, baseImage);

        await ApiManager.start(apiJob, {
            target: 'image-inpaint',
            category: 'operation',
            options: {
                style: activeStage.settings.style,
                allow_multiple_outputs: true,
                num_inference_steps: activeStage.settings.num_inference_steps,
                batch_size: 1,
                batch_count: 4,
                cfg_scale: activeStage.settings.cfg_scale,
                width: activeStage.mainJob.apiJob.output[0].metadata.image_width,
                height: activeStage.mainJob.apiJob.output[0].metadata.image_height,
                inpainting_fill: activeStage.settings.inpainting_fill,
                inpainting_area: activeStage.settings.inpainting_area,
                mask_mode: activeStage.settings.mask_mode,
                inpainting_area_padding: activeStage.settings.inpainting_area_padding,
                mask_blur: activeStage.settings.mask_blur,
                denoising_strength: activeStage.settings.denoising_strength
            }
        });

        apiJob =  await ApiManager.get(apiJob);
        await this._waitUntilComplete(apiJob);

        let finalJob =  await ApiManager.get(apiJob);
        let sysJob = new ApiJob();
        sysJob.apiJob = finalJob;
        activeStage.sysJobs.push(sysJob);
        activeStage.layout.sidebar_bot = true;
        job.state = JOB_STATE_SELECT_OUTPUT;

        EventBus.$emit(EVENT_JOB_SYS_SUCCESS, {});
    }

    async _waitUntilComplete(job, incomplete = 0) {
        return new Promise((resolve, reject) => {

            async function _waitUntilCompletePromise(job, incomplete = 0) {
                let apiJob = await ApiManager.get(job);
                if (null === apiJob) {
                    resolve();

                    return;
                }

                if (apiJob.status.code === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_COMPLETE) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;

                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilCompletePromise(job, ++incomplete);
                    }, 1000);
                    return;
                }

                setTimeout(() => {
                    _waitUntilCompletePromise(job);
                }, 1000);

                return;
            }

            _waitUntilCompletePromise(job, incomplete);

            return;
        })
    }

    async initFromJobId(id, apiId) {
        this.store = useResultPageStore();
        let job = this.store.getJobById(id);
        job.state = JOB_STATE_PROCESSING;

        let apiJob = await ApiManager.get({id: apiId});

        if (404 === apiJob) {
            this.store.getJobById(id).state = JOB_STATE_NOT_FOUND;
            Analytics.send('result_job', 'not_found', {apiJob: {id: apiId}});


            return;
        }

        job.apiJob = apiJob;
        window.qgJob = apiJob;

        EventBus.$emit(EVENT_JOB_INIT_SUCCESS, job);

        await this._waitUntilCompleteJob(id, apiJob);
    }

    async _waitUntilCompleteJob(id, job, incomplete = 0) {
        this.store = useResultPageStore();

        let apiJob = await ApiManager.get(job);

        if (404 === apiJob) {
            this.store.getJobById(id).state = JOB_STATE_NOT_FOUND;

            return;
        }

        if (null === apiJob) {
            setTimeout(() => {
                this._waitUntilCompleteJob(id, job, ++incomplete);
            }, 2000);

            return;
        }
        window.qgJob = apiJob;
        this.store.getJobById(id).apiJob = apiJob;

        if (apiJob.status.code === JOB_STATE_FAILED) {
            Analytics.send('result_job', 'failed', this.store.getJobById(id));

            this.store.getJobById(id).state = JOB_STATE_FAILED;
            EventBus.$emit(EVENT_JOB_FAIL, {});

            return;
        }

        if (apiJob.status.code === JOB_STATE_COMPLETE) {
            Analytics.send('result_job', 'complete', this.store.getJobById(id));

            this.store.getJobById(id).state = this.store.getJobById(id).apiJob.status.code;
            this._populateBase64Images(id);

            EventBus.$emit(EVENT_JOB_COMPLETE, this.store.getJobById(id))

            return;
        }

        if (apiJob.status.code === JOB_STATE_INCOMPLETE) {

            if (incomplete > 60) {
                Analytics.send('result_job', 'failed_incomplete', this.store.getJobById(id));

                job.state = JOB_STATE_FAILED;
                this.store.getJobById(id).state = JOB_STATE_FAILED;

                return;
            }

            setTimeout(() => {
                this._waitUntilCompleteJob(id, job, ++incomplete);
            }, 2000);

            return;
        }

        setTimeout(() => {
            this._waitUntilCompleteJob(id, job);
        }, 2000);

        return;
    }

    async encodeImageToBase64Url(imageUrl) {
        try {
            const response = await axiosWrapper.get(imageUrl, {}, {responseType: 'blob'});
            const blob = await response.data;
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result.split(',')[1]);
                };
                reader.onerror = () => {
                    reject(new Error('Error reading image'));
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            return null;
        }
    }

    decodeBase64ToImageUrl(base64String, mimeType) {
        return `data:${mimeType || 'image/png'};base64,${base64String}`;
    }

    _populateBase64Images(id) {
        return;
        this.store = useResultPageStore();

        let job = this.store.getJobById(id);

        job.apiJob.output.forEach((output) => {
            encodeImageToBase64(output.uri).then((base64String) => {
                if (null === base64String) {
                    job.state = JOB_STATE_FAILED;
                }
                job.base64_output_images.push(decodeBase64ToImageUrl(base64String));
            }).catch((err) => {
                job.state = JOB_STATE_FAILED;
            }).finally(() => {
                if (job.state === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});
                }
            });
        });
    }



    openOperation(id, operation) {
        this.store = useResultPageStore();

        const job = this.store.getJobById(id);

        let operationLink = job.apiJob.sat_links.reconvert.filter((obj) => {
            return obj.operation === operation;
        });

        satReconvert.redirectWithStorage(operationLink[0].href.link, job.apiJob.output[0].uri);
    }

    getExtensionFromOutput(output) {
        let lastDotIndex = output.uri.lastIndexOf('.');
        return output.uri.substring(lastDotIndex + 1);
    }

    getFilenameFromOutput(output) {
        let lastDotIndex = output.uri.lastIndexOf('/');
        return output.uri.substring(lastDotIndex + 1);
    }

    getInputByOutputSource(output, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === output.source.input[0] || obj.id === output.source.input[0];
        });
    }

    getInputByWarningSource(warning, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === warning.id_source || obj.id === warning.id_source;
        });
    }

    getInputById(inputid, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === inputid || obj.id === inputid;
        });
    }

    getMissingInputs(job) {
        let missingIds = this.getMissingInputIds(job);
        let missingInputs = [];

        missingIds.forEach((inputId) => {
            let missingInput = this.getInputById(inputId, job);
            missingInputs.push(missingInput[0]);
        });

        return missingInputs;
    }

    getMissingInputIds(job) {
        const inputIds = this.getInputIdsFromJob(job);
        const inputIdsFromOutputs = this.getInputIdsFromOutputs(job);

        return inputIds.filter((id) => !inputIdsFromOutputs.includes(id));
    }

    getInputIdsFromJob(job) {
        let inputIds = [];

        const inputs = job.apiJob.input;

        inputs.forEach((input) => {
            if (testIsNonEmptyString(input.id_api)) {
                inputIds.push(input.id_api);
            } else {
                inputIds.push(input.id);
            }
        });

        return inputIds;
    }


    getInputIdsFromOutputs(job) {
        let inputIds = [];

        const outputs = job.apiJob.output;

        outputs.forEach((output) => {
            inputIds = inputIds.concat(output.source.input);
        });

        return inputIds;
    }

    isCompressJob(job) {
        if (job.apiJob.sat.operation.includes('compress')) {
            return true;
        }

        if (job.apiJob.sat.operation === 'compress') {
            return true;
        }

        return false;
    }

    getOutputCompressDiff(output, job) {
        let input = this.getInputByOutputSource(output, job);
        if (input.length === 0) {
            return {
                diff_size: 0,
                diff_perc: 0
            };
        }

        return {
            diff_size: input[0].size - output.size,
            diff_perc: (100 - ((100 / input[0].size) * output.size)).toFixed(2)
        };
    }

    isOutputSmaller(output, job) {
        let input = this.getInputByOutputSource(output, job);
        if (input.length === 0) {
            return null;
        }

        return output.size < input[0].size;
    }

    async exportStage(stage) {
        await Analytics.send('magic_editor_action', 'export_stage', stage.mainJob)

        let locale = satGlobals.getLocale();
        if (locale !== 'en') {
            window.open('/' + locale + '/result#j=' + stage.mainJob.apiJob.id);
        } else {
            window.open('/result#j=' + stage.mainJob.apiJob.id);
        }
    }

    async exportSysJob(stage) {
        await Analytics.send('magic_editor_action', 'export_sys_job', stage.sysJobs[0])

        let locale = satGlobals.getLocale();
        if (locale !== 'en') {
            window.open('/' + locale + '/result#j=' + stage.sysJobs[0].apiJob.id);
        } else {
            window.open('/result#j=' + stage.sysJobs[0].apiJob.id);
        }
    }
}

export default new JobManager();
